import React from 'react'

function ArTitle({title}) {
  return (
    <h3 className='music-grid-block__title text-l text-caps mob-m-1 mob-mt-1_2'>{title}</h3>
  )
}

export default ArTitle